<template>
  <div id="noproducts-view">
    <div class="noproducts">
      <span class="text-center text-grey-text">{{ $t("catalog.noproducts") }}</span>
      <img src="@/assets/img/img-placeholder-horizontal.png">
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "NoProducts",
  metaInfo() {
      return { 
          title: `${this.$t('noproducts.meta.title')} - ${this.resort.name}`,
          meta: [
              { name: 'description', content:  this.$t('noproducts.meta.description')}, 
          ]
      }
  },
  computed: {
    ...mapGetters("resort", ["resort"])
  }
};
</script>

<style scoped>
  #noproducts-view {
    @apply pt-12
  }

  img {
    @apply hidden;
  }

  .noproducts {
    background: url('../assets/img/img-placeholder-vertical.png') no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    min-height: calc(100vh - 48px);
    @apply flex flex-col items-center
  }

  span {
    @apply mt-1/4 text-xl
  }

  @screen lg {
    #noproducts-view {
      min-height: 70vh;
      @apply flex flex-col-reverse pt-0
    }

    .noproducts {
      height: 100%;
      background-image: none;
      @apply flex flex-col justify-between min-h-full
    }

    span {
      @apply text-center mb-1/2
    }

    img {
      width: 461px;
      @apply block;
    }
  }

</style>
